import React, {useEffect, useState} from 'react';
import AppBar from "../../Components/AppBar";
import {Container} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import Radio from "@material-ui/core/Radio/Radio";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Box from "@material-ui/core/Box";
import {formatCurrency} from "../../../../utils";
import {useCheckout} from "../../Providers/CheckoutProvider";
import {callAPI, useAPI} from "../../../../lib/common";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import Alert from '@material-ui/lab/Alert';
import {useHistory, useRouteMatch} from "react-router";
import TermsOfPurchaseDialog from "./Components/TermsOfPurchaseDialog";
import Link from "@material-ui/core/Link";
import LoadingButton from "../../../Common/LoadingButton";
import {Trans, useTranslation} from "react-i18next";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TextField from "@material-ui/core/TextField";


function createElementFromHTML(htmlString) {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();

  // Change this to div.childNodes to support multiple top-level nodes
  return div.firstChild;
}

function getDOMElementAttributes(domElement) {
  const attributes = {};
  for (const attribute of domElement.attributes) {
    attributes[attribute.name] = attribute.value;
  }
  return attributes;
}

const makeLinks = (text) => {
  console.log('Make links', text);

  const textParts = text.split(/(<a [^>]+>[^<]+<\/a>)|(<br\s*\/*>)/ig)
  const parts = [];
  for (const part of textParts) {
    // I'm not sure why/how this happends
    if (part === undefined || part === "") {
      continue;
    }
    const match = part.match(/<a ([^>]+)>([^<]+)<\/a>/i);
    if (match) {
      const domElement = createElementFromHTML(part);
      const attributes = getDOMElementAttributes(domElement);
      parts.push(<Link {...attributes}>{match[2]}</Link>);
    } else if (part.substr(0, 3) == '<br') {
      parts.push(<br/>)
    } else {
      parts.push(part);
    }
  }
  return parts;
}

const useStyles = makeStyles(theme => ({
  button: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  link: {
    textDecoration: 'underline'
  },
  paymentOptions: {},
  listItem: {
    marginBottom: '2px',
    backgroundColor: '#F6F6F6'
  },
  selected: {
    '&.MuiListItem-root, &.MuiListItem-root:active, &.MuiListItem-root:hover': {
      backgroundColor: theme.palette.secondary.light
    }
  },
  root: {
    '& .MuiTextField-root': {
      marginBottom: theme.spacing(1),
    },
  },
  container: {
    minHeight: '100%',
    marginBottom: theme.spacing(2),
  },
  section: {
    backgroundColor: 'white',
    boxShadow: '0px 2px 4px #00000029',
  },
  orderContent: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    '& > li': {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '16px'
    },
    '& > li.total-price': {
      fontSize: '20px'
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexShrink: 0,
    fontWeight: 'bold'
  },
  rebateCodeInput: {
    marginBottom: theme.spacing(2),
  },
  accordionDetails: {
    display: 'block'
  },
  rebateCodeButton: {
    whiteSpace: 'nowrap'
  },
  accordionContainer: {
    boxShadow: 'none'
  },
  paymentHeader: {
    paddingTop: theme.spacing(2)
  }
}));

export default () => {
  const {state, setPaymentOption, requestTransactionUuid, setRebateCode} = useCheckout();
  const [paymentOptions, loading] = useAPI(`/m/api/checkout/delivery-options/${state.deliveryOption.uuid}/payment-options`)
  const [haveActiveRebateCodes, loadingActiveRebateCodes] = useAPI(`/m/api/checkout/rebate-codes/have-active-rebate-codes`)
  const classes = useStyles();
  const [showTermsOfPurchase, setShowTermsOfPurchase] = useState(false);
  const theme = useTheme();
  const disableGutters = useMediaQuery(theme.breakpoints.down('sm'));
  const [useRebateCode, setUseRebateCode] = useState(false);
  const [rebateCodeError, setRebateCodeError] = useState(null);
  const [inputRebateCode, setInputRebateCode] = useState('');
  const [t] = useTranslation();

  useEffect(() => {
    console.log('State',)
    if (state.transactionUuid) {
      // We need a real redirect here:
      document.location.href = '/m/cart/checkout/payment?transaction=' + state.transactionUuid;
    }

  }, [state && state.transactionUuid])

  useEffect(() => {
    if (!loading && paymentOptions && paymentOptions.length == 1) {
      setPaymentOption(paymentOptions[0])
    }
  }, [paymentOptions, loading]);

  const handleRebateCode = (e) => {
    e.preventDefault();
    setRebateCodeError(null)
    const rc = inputRebateCode;
    callAPI('/m/api/checkout/rebate-codes/use-rebate-code', 'POST', {code: rc})
      .then(r => {
        if (!r.error) {
          setRebateCode({code: r.code, text: r.text});
        } else {
          setRebateCodeError(r.error);
        }
      });
  }

  const handleTOPClick = (e) => {
    setShowTermsOfPurchase(true);
    e.preventDefault();
  }

  if (loading || loadingActiveRebateCodes) {
    return <div>Loading</div>
  }

  return <React.Fragment>
    <AppBar/>
    <Container disableGutters={disableGutters} maxWidth="sm">
    <div className={classes.container}>
      <Container maxWidth="sm" className={classes.section}>
        <Typography variant="h4" className={classes.paymentHeader}>
          <Trans>Payment</Trans>
        </Typography>
        <Typography variant="h6">
          <Trans>Choose payment option</Trans>
        </Typography>
      </Container>
      <Box mb={2}>
        <Container maxWidth="sm" disableGutters={disableGutters} className={classes.section}>
          <Box pb={1}>
            <List className={classes.paymentOptions} disablePadding={true}>
              {paymentOptions.map((po) => {
                const description = makeLinks(
                  (po.mobileDescription != undefined)
                    ? po.mobileDescription : po.description);

                const labelId = po.type;
                console.log('Delivery option', po);
                return <ListItem key={po.uuid} button
                                 selected={state.paymentOption && po.uuid === state.paymentOption.uuid}
                                 classes={{selected: classes.selected}}
                                 onClick={() => setPaymentOption(po)} className={classes.listItem}>
                  <ListItemIcon>
                    <Radio edge="start"
                           checked={state.paymentOption && po.uuid === state.paymentOption.uuid}
                           inputProps={{'aria-labelledby': labelId}}
                    />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={po.title} secondary={description}/>
                  <Box>{/*formatCurrency(po.price)*/}</Box>
                </ListItem>
              })}
            </List>
          </Box>
        </Container>
      </Box>

      {haveActiveRebateCodes.haveActiveRebateCodes &&
      <Box mb={2}>
        <Container maxWidth='sm' disableGutters={disableGutters} className={classes.section}>
          <Accordion expanded={useRebateCode || state.rebateCode}
                     onChange={() => setUseRebateCode((rc) => !rc)}
                     classes={{root: classes.accordionContainer}}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon/>}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography className={classes.heading}>
                <Trans>Rebate Code</Trans>
              </Typography>
            </AccordionSummary>
            <AccordionDetails classes={{root: classes.accordionDetails}}>
              {state.rebateCode &&
              <div>
                {state.rebateCode.text}
              </div>}

              {!state.rebateCode && <form onSubmit={handleRebateCode}>
                <Typography variant='h6'>
                  <Trans>Do you have a rebate code?</Trans>
                </Typography>
                <Typography variant='body1'>
                  <Trans>Fill the textbox and click activate to get rebate.</Trans>
                </Typography>
                <Box display={'flex'} flexDirection='column' alignItems='flex-end'>
                  <TextField label={t('Rebate Code')} name={'rebate-code'} value={inputRebateCode}
                             onChange={e => {
                               setRebateCodeError(null)
                               setInputRebateCode(e.target.value)
                             }}
                             error={!!rebateCodeError}
                             helperText={rebateCodeError}
                             classes={{root: classes.rebateCodeInput}}
                             fullWidth
                  />
                  <Button type='submit' color='primary' variant='contained' classes={{root: classes.rebateCodeButton}}>
                    <Trans>
                      Activate
                    </Trans>
                  </Button>
                </Box>
              </form>}
            </AccordionDetails>
          </Accordion>
        </Container>
      </Box>
      }

      <Container maxWidth="sm" className={classes.section} disableGutters={true}>
        <Box mt={2} mb={2} pt={2}>
          <Container maxWidth="sm" >
            <ul className={classes.orderContent}>
              {state.orderInfo && state.orderInfo.orderLines
                .filter(ol => ol.type > 0)
                .map((ol, idx) => {
                  return <li key={ol.description} className={`${ol.type == 4 && 'total-price'}`}>
                    <div>{ol.description}</div>
                    <div>{formatCurrency(ol.linePrice)}</div>
                  </li>
                })}
            </ul>
          </Container>
        </Box>


        <Box mt={2} mb={2}>
          <Container maxWidth="sm">
            <Trans>By confirming the order you agree to {{portalName: window.NTLF_CONFIG.portal.companyName}}'s <Link
              onClick={handleTOPClick} className={classes.link}>terms of purchase</Link>.</Trans>
          </Container>
        </Box>

        <Container maxWidth="sm">
          {state.requestTransactionUuidError && <Alert severity="error">{state.requestTransactionUuidError}</Alert>}
          <Box mt={2} mb={2} pb={2}>
            <LoadingButton fullWidth variant="contained" color="primary" disabled={!state.paymentOption}
                           isLoading={state.requestingTransactionUuid || state.transactionUuid}
                           onClick={() => requestTransactionUuid()}>
              <Trans>Confirm order</Trans>
            </LoadingButton>
          </Box>
        </Container>
      </Container>
    </div>
    </Container>
    <TermsOfPurchaseDialog open={showTermsOfPurchase} onClose={() => setShowTermsOfPurchase(false)}/>
  </React.Fragment>
}